export { default } from 'cccisd-game-pickandpeck';
